class Animation {
    constructor(name, elem, func, param=null, delay=0, on=true) {
        this.name = name;
        this.elem = elem;
        this.function = func;

        this.on = on;
        this.delay = delay;
        this.iterationDelayValue = 0;
        this.iterationDelayCounter=0;
        this.count = 0;
        this.paused = false;
        this.delayed = delay > 0;
        this.delayCounter = 0;

        if (param) {
            for(let key in param) {
                this[key] = param[key];
            }
        }
    }

    iterate(top) {
        // if(this.elem) {
            if(this.on && !this.paused) {
                if(this.delayed) {
                    this.delayed = this.delayCounter < this.delay;
                    this.delayCounter++;
                } else {
                    if(this.iterationDelayReached()){
                        this.function(this, top);
                        this.count++;
                    }
                }
            }
        // } else{
        //     this.on = true;
        // }
        return this.on;
    }

    switchOff(fallback=null) {
        if(this.on){
            this.on = false;
            if(fallback) {
                fallback(this);
            }
        }
    }

    pause(delay=0) {
        if(delay > 0) {
            this.delay = delay;
            this.delayCounter = 0;
            this.delayed = true;
            this.paused = false;
        } else {
            this.paused = true;
        }
    }

    continue(){
        this.delay = 0;
        this.delayed = false;
        this.paused = false;
    }

    iterationDelay(delay) {
        this.iterationDelayValue = delay;
    }

    iterationDelayReached() {
        if(this.iterationDelayCounter >= this.iterationDelayValue) {
            this.iterationDelayCounter = 0;
            return true;
        } else {
            this.iterationDelayCounter ++;
            return false;
        }
    }

    hasFinished(){
        return !this.on;
    }


    print() {console.log(this.name + " -- " + this.count);}
}

export default Animation;

